/**

Copyright (c) 2018, MOBICOOP. All rights reserved.
This project is dual licensed under AGPL and proprietary licence.

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.
This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details.
You should have received a copy of the GNU Affero General Public License
along with this program. If not, see gnu.org/licenses.

Licence MOBICOOP described in the file
LICENSE
**************************/

<template>
  <ion-page class="ion-page">
    <ion-header class="ion-no-border">
      <ion-toolbar color="primary">
        <ion-buttons slot="start">
          <ion-back-button default-href="/carpools/home"></ion-back-button>
        </ion-buttons>
        <h1 class="ion-text-center">{{ $t('BankAccount.title') }} </h1>
      </ion-toolbar>
    </ion-header>

    <ion-content color="primary" forceOverscroll="false">
      <div class="mc-white-container">

        <div class="ion-text-center" v-if="loading">
          <ion-icon size="large" color="primary" class="rotating" name="sync"></ion-icon>
        </div>

        <div v-if="!loading">

        <ion-card class="bank-info" color="warning">
          <ion-card-content class="d-flex" >
            <ion-icon style="min-height: 25px; min-width: 25px; margin-top: 3px; margin-right: 16px" name="alert"></ion-icon>
            <div style="font-size: 14px;">Pour recevoir des paiements en ligne, il est nécessaire de renseigner l'ensemble des informations ci-dessous.</div>
          </ion-card-content>
        </ion-card>
        <ion-item>
          <ion-label position="stacked">{{$t('BankAccount.iban')}} *</ion-label>
          <ion-input
            type="text"
            :placeholder="$t('BankAccount.iban') + '*'"
            :value="bankAccount.iban"
            :disabled="bankAccount.id"
            @input="bankAccount.iban = $event.target.value"
          >
          </ion-input>
        </ion-item>
        <div v-if="v$.bankAccount.iban.$error">
          <div class="mc-error-label"  v-if="v$.bankAccount.iban.required.$invalid">{{$t('Validation.required')}}</div>
          <div class="mc-error-label"  v-if="v$.bankAccount.iban.minLength.$invalid">{{$t('Validation.minLengthIBAN')}}</div>
        </div>

        <ion-item>
          <ion-label position="stacked">{{$t('BankAccount.bic')}}</ion-label>
          <ion-input
            type="text"
            :placeholder="$t('BankAccount.bic')"
            :value="bankAccount.bic"
            :disabled="bankAccount.id"
            @input="bankAccount.bic = $event.target.value"
          >
          </ion-input>
        </ion-item>
        <div v-if="v$.bankAccount.bic.$error">
          <div class="mc-error-label"  v-if="v$.bankAccount.bic.required.$invalid">{{$t('Validation.required')}}</div>
          <div class="mc-error-label"  v-if="v$.bankAccount.bic.minLength.$invalid">{{$t('Validation.minLengthBIC')}}</div>
        </div>

        <br>
        <ion-item  v-on:click="goGeoSearch('update_bank_address', 'search')">
          <ion-label position="stacked">{{$t('BankAccount.address')}} *</ion-label>
          <ion-input
            type="text"
            name="address"
            :value="formatAddress(bankAccount.address)"
            :disabled="bankAccount.id"
            readonly="true"
            class="no-clickable ellipsis"
            v-bind:placeholder="$t('BankAccount.address')"
          ></ion-input>
        </ion-item>
        <div v-if="v$.bankAccount.address.$error">
          <div class="mc-error-label"  v-if="v$.bankAccount.address.required.$invalid">{{$t('Validation.required')}}</div>
          <div class="mc-error-label"  v-if="v$.bankAccount.address.fullAddress.$invalid">{{$t('Register.fullAddress')}}</div>
        </div>

        <div v-if="bankAccount.id">
          <br>
          <ion-label position="stacked">{{$t('BankAccount.identity')}} *</ion-label>
          <div style="line-height: 18px"><small>{{$t('BankAccount.identity-desc')}}</small></div>
          <div class="validationStatus">
            <div v-if="bankAccount.validationStatus == 0" class="text-center">
              <ion-text color="secondary" class="d-flex justify-center align-center">
                <ion-icon class="status-icon" name="hourglass"></ion-icon>
                <b>{{$t('BankAccount.waiting')}}</b>
              </ion-text>
            </div>
            <div v-if="bankAccount.validationStatus == 1" class="text-center">
              <ion-text color="success" class="d-flex justify-center align-center">
                <ion-icon class="status-icon" name="checkmark"></ion-icon>
                <b>{{$t('BankAccount.accepted')}}</b>
              </ion-text>
            </div>
            <div v-if="bankAccount.validationStatus == 2" class="text-center">
              <ion-text color="danger" class="d-flex justify-center align-center">
                <ion-icon class="status-icon" name="close"></ion-icon>
                <b>{{$t('BankAccount.refused')}}</b>
              </ion-text>
            </div>
            <div v-if="bankAccount.validationStatus == 3" class="text-center">
              <ion-text color="danger" class="d-flex justify-center align-center">
                <ion-icon class="status-icon" name="close"></ion-icon>
                <b>{{$t('BankAccount.outdated')}}</b>
              </ion-text>
            </div>
          </div>
          <input ref="docInput" style="display: none" type="file" @change="changeDoc($event)" />
          <div v-if="(!bankAccount.validationAskedDate || !(bankAccount.validationStatus == 0 || bankAccount.validationStatus == 1))">
          <div class="d-flex ion-justify-content-between ion-margin-bottom" v-for="(file, index) in files">
            <div class="d-flex">
              <ion-icon style="margin-top: 5px; min-width: 16px" name="document-outline" class="ion-margin-end"></ion-icon>
              {{file.name}}
            </div>
            <ion-icon style="min-width: 32px" class="ion-margin-start" @click="removeFile(index)" color="danger" size="large" name="trash-outline"></ion-icon>
          </div>
          </div>
          <ion-button v-if="(!bankAccount.validationAskedDate || !(bankAccount.validationStatus == 0 || bankAccount.validationStatus == 1)) && files.length < 2" class='mc-small-button ion-margin-bottom' color="primary" fill="outline" expand="block" @click="$refs.docInput.click()">
            <ion-icon class="ion-margin-end" name="create"></ion-icon> {{ files.length >= 1 ? 'Ajouter un document d\'identité (verso)' : 'Ajouter un document d\'identité' }}
          </ion-button>
          <ion-button v-if="(!bankAccount.validationAskedDate || !(bankAccount.validationStatus == 0 || bankAccount.validationStatus == 1)) && files.length > 0" class='mc-small-button' color="primary" fill="outline" expand="block" @click="uploadDocumentValidation()">
            <ion-icon class="ion-margin-end" name="cloud-upload-outline"></ion-icon> {{ files.length > 1 ? 'Envoyer mes documents d\'identité' : 'Envoyer mon document d\'identité' }}
          </ion-button>

        </div>

        <br>
        <ion-button class='mc-small-button' :color="bankAccount.id ? 'danger' : 'success'" expand="block" @click="postBankAccount()">
            <span v-if="loading">
            <ion-icon size="large" class="rotating" name="sync"></ion-icon>
          </span>
          <span v-if="!loading">
          {{ bankAccount.id ? $t('BankAccount.disable') : $t('Commons.save') }}
          </span>
        </ion-button>
        </div>
      </div>
    </ion-content>
  </ion-page>
</template>

<style lang="scss">
.validationStatus {
  margin-top: 10px;
  margin-bottom: 10px;
}

.bank-info {
  margin: 0px;
  margin-bottom: 16px;
}
</style>

<script>
  import {toast} from "../../Shared/Mixin/toast.mixin";
  import {required, minLength} from '@vuelidate/validators';
  import { address } from '../../Shared/Mixin/address.mixin';
  import Compressor from 'compressorjs';
  import useVuelidate from "@vuelidate/core";

  export default {
    name: 'bankAccount',
    setup () {
      return { v$: useVuelidate() }
    },
    data () {
      return {
        loading: false,
        fullAddressRequired: JSON.parse(process.env.VUE_APP_REGISTER_FULL_ADDRESS),
        files: []
      }
    },
    mixins: [toast, address],
    props : [],
    created() {
      // this.$store.commit('reset_bank_account');
      if (!this.bankAccount) {
        this.$store.commit('reset_bank_account');
      }
      this.getBankAccount()
    },
    validations() { return {
      bankAccount: {
        iban: {
          required,
          minLength: minLength(16)
        },
        bic: {
          minLength: minLength(8)
        },
        address: {
          required,
          fullAddress(address) {
            console.log(address)
            return this.fullAddressRequired ? (address ? (address.type === "housenumber" || address.type === "street" )  : false) : true;
          }
        }
      }
    }
    },
    computed: {
      bankAccount() {
        let bankAccount = this.$store.state.paymentStore.bankAccount;
        if(bankAccount && bankAccount.iban){
          bankAccount.iban = bankAccount.iban.replace(/\s+/g, '')
        }
        return bankAccount;
      },
    },
    methods: {
      goGeoSearch(type, action) {
        this.$router.push({ name: "geoSearch", query: { type, action, fullAddressRequired: this.fullAddressRequired }});
      },
      getBankAccount() {
        this.loading = true;
        this.$store.dispatch('getBankAccount').then(res =>{
          this.bankAccount = res;
          setTimeout(() => {
            this.v$.$reset();
          }, 0)
          this.loading = false
        }).catch(() => {
          this.loading = false
        })
      },
      postBankAccount() {
        if (this.bankAccount.id) {
          this.$store.dispatch('disableBankAccount', this.bankAccount.id)
        } else {
          this.v$.$reset();
          this.v$.$touch();
          if (!this.v$.$invalid) {
            this.loading = true
            this.$store.dispatch('postBankAccount', this.bankAccount)
              .then(res => {
                this.getBankAccount()
                this.presentToast(this.$t("BankAccount.success"), 'success')
              })
              .catch(err => {
                this.loading = false
                if (err.response.data['hydra:description'].includes('iban')) {
                  this.presentToast(err.response.data['hydra:description'], 'danger')
                } else {
                  this.presentToast(this.$t("Commons.error"), 'danger')
                }
              });
          }
        }
      },
      changeDoc(e) {
        const file = e.target.files[0];
        if (file) {
          this.compressFile(file);

        }
      },
      compressFile: function (file) {
        const context = this;
        if (file.type === 'application/pdf') {
          this.files.push(file)
          // this.uploadDocumentValidation(file, file.name, {type: file.type});
        } else {
          new Compressor(file, {
            convertSize: 1000000,
            success(result) {
              if (result) {
                context.files.push(new File([result], file.name, {type: result.type}))
                //context.uploadDocumentValidation(new File([result], file.name, {type: result.type}));
              }
            },
            error(err) {
              context.presentToast(context.$t("Commons.error"), 'danger')
            },
          });
        }
      },
      uploadDocumentValidation() {
        const params = {}
        if (this.files[0]) {
          params.file = this.files[0]
        }
        if (this.files[1]) {
          params.file2 = this.files[1]
        }
        this.$store.dispatch('sendValidationDocument', params)
          .then(res => {
           this.getBankAccount()
            this.presentToast(this.$t("BankAccount.document-success"), 'success')
          })
          .catch(err => {
            this.presentToast(this.$t("Commons.error"), 'danger')
          });
      },
      removeFile(index) {
        this.files.splice(index, 1)
      }
    }
  }
</script>
